
import { useState, useEffect } from 'react';
import Icon from '../../../components/ui/AppIcon';
import './Footer.css'

const Footer = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [currentYear, setCurrentYear] = useState(2025);

  useEffect(() => {
    setIsHydrated(true);
    setCurrentYear(new Date().getFullYear());
  }, []);

  const quickLinks = [
    { label: 'Program Overview', href: '#program-overview' },
    { label: 'Specializations', href: '#specializations' },
    { label: 'Fee Structure', href: '#fees-emi' },
    { label: 'Success Stories', href: '#success-stories' },
  ];

  const contactInfo = [
    { icon: 'PhoneIcon', text: '+91 9405709042', href: 'tel:+919405709042' },
    { icon: 'EnvelopeIcon', text: 'inquiry@profcyma.com', href: 'mailto:inquiry@profcyma.com' },
    { icon: 'ChatBubbleLeftRightIcon', text: 'support@profcyma.com', href: 'mailto:support@profcyma.com' },
    { icon: 'MapPinIcon', text: 'Pune, Maharashtra, India', href: '#' },
  ];

  return (
    <footer className="bg-gradient-to-br from-primary to-secondary text-primary-foreground  Footer">
      <div className="max-w-content mx-auto px-section-margin py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* About Section */}
          <div>

    <div className='logo_holder mb-3'>
                  <img src='/assets/images/logo/logo.png' className='logo'/>
                </div>

            {/* <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-primary-foreground/20 rounded-lg flex items-center justify-center">
                <span className="text-primary-foreground font-bold text-xl">DY</span>
              </div>
              <div>
                <div className="font-bold text-lg">D.Y. Patil</div>
                <div className="text-sm text-primary-foreground/80">Online MBA</div>
              </div>
            </div> */}
            <p className="text-primary-foreground/80 text-sm leading-relaxed mb-6" style={{color:"white"}}>
              Empowering working professionals with UGC-approved Online MBA programs designed for career advancement without employment interruption.
            </p>
            <div className="flex items-center space-x-2">
              <Icon name="CheckBadgeIcon" size={20} variant="solid" />
              <span className="text-sm">UGC Approved</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-primary-foreground/80 hover:text-primary-foreground transition-default text-sm flex items-center space-x-2 quick_links"
                  >
                    <Icon name="ChevronRightIcon" size={16} variant="solid" />
                    <span>{link.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-6">Contact Us</h3>
            <ul className="space-y-4">
              {contactInfo.map((info, index) => (
                <li key={index}>
                  <a
                    href={info.href}
                    className="flex items-start space-x-3 text-primary-foreground/80 hover:text-primary-foreground transition-default quick_links"
                  >
                    <Icon name={info.icon as any} size={20} className="flex-shrink-0 mt-0.5" variant="solid" />
                    <span className="text-sm">{info.text}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA Section */}
          <div>
            <h3 className="font-bold text-lg mb-6">Ready to Start?</h3>
            <p className="text-primary-foreground/80 text-sm mb-6">
              Get instant counseling and personalized career guidance from our experts.
            </p>
            <a
              href="#apply-now"
              className="block w-full bg-accent text-accent-foreground text-center px-6 py-3 rounded-lg font-bold shadow-cta hover:bg-accent/90 transition-default mb-4"
            >
              Apply Now
            </a>
            <div className="flex space-x-3">
              <a
                 href="https://wa.me/919730088168"
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 flex items-center justify-center bg-success text-success-foreground px-4 py-2 rounded-lg hover:bg-success/90 transition-default"
              >
                <Icon name="ChatBubbleLeftRightIcon" size={20} variant="solid" />
              </a>
              <a
                href="tel:+919405709042"
                className="flex-1 flex items-center justify-center bg-success text-success-foreground px-4 py-2 rounded-lg hover:bg-success/90 transition-default"
              >
                <Icon name="PhoneIcon" size={20} variant="solid" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-primary-foreground/20">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-primary-foreground/80 quick_links">
              © {isHydrated ? currentYear : 2025} D.Y. Patil Online MBA. All rights reserved.
            </p>
            {/* <div className="flex items-center space-x-6">
              <a href="#" className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-default quick_links">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-default quick_links">
                Terms of Service
              </a>
              <a href="#" className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-default quick_links">
                Refund Policy
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;